import React, { Component } from "react";
import Popup from "./Popup";

class ButtonBaja extends Component {
    constructor(props) {
        super(props);

        /*Bindings de metodos a la clase*/
        this.darBajaATarjeta = this.darBajaATarjeta.bind(this);
    }
    /**
     * 
     * @param {any} motivoId
     */
    darBajaATarjeta(motivoId) {
        const { actualizarNovedadEstado, codigoNovedad, entidadTipo, guardarNovedadBloqueo, novedad, tarjeta } = this.props;

        if (novedad.novedadCancelada) {
            actualizarNovedadEstado(novedad.novedadCancelada.Id, 1, codigoNovedad, entidadTipo, tarjeta.CuentaTarjetaId);
        } else {
            /*es la primera vez que entra hay que crear la novedad de bloqueo*/
            let nuevaNovedad = {
                Id: null,
                NovedadCampoCodigo: codigoNovedad,
                ValorAnterior: null,
                ValorNovedad: motivoId,
                EstadoId: 1,
                TarjetaCreditoId: tarjeta.TarjetaCreditoId,
                CuentaTarjetaId: tarjeta.CuentaTarjetaId
            };

            return guardarNovedadBloqueo(nuevaNovedad);
        }
    }
    /**
     * 
     */
    render() {
        const { novedad, codigoNovedad, motivos, tarjeta, puedeEjecutar } = this.props;
        let componente = null;
        if (puedeEjecutar == false) {
            componente = <a className="none-text-decoration ti-trash disabled"></a>
        } else {
            componente = (
                <Popup
                    clave={"popup-baja-" + tarjeta.TarjetaCreditoId}
                    motivos={motivos}
                    titulo="Para solicitar la baja de tarjeta, haga clic en Listo"
                    mensajeError="Por favor, seleccione un motivo de baja"
                    mostrarCombo={false}

                    selectCombo={(value) => this.props.selectCombo(2, codigoNovedad, value)}
                    confirmar={(motivoId) => this.darBajaATarjeta(motivoId)}>

                    <a className="clickable none-text-decoration ti-trash" data-toggle="dropdown"></a>
                </Popup>
            )
        }

        return componente;
    }
}

export default ButtonBaja;